import { Route, Routes } from 'react-router-dom';
import MelismesHome from './Home';

function Router() {
  return (
    <Routes>
      <Route exact path="/melismes/home" element={<MelismesHome />} />
    </Routes>
  );
}

export default Router;
